import { debounce as _debounce } from 'lodash';

import fetchActiveContainers from './fetchActiveContainers';

const fetchActiveContainersDebounce = _debounce(fetchActiveContainers, 350);

export default fetchActiveContainersDebounce;
